import map from "lodash/map";
import assign from "lodash/assign";
import pickBy from "lodash/pickBy";

const _ = { map, assign, pickBy };
const lowerUnder = str => str.replace(/[A-Z]/g, (n) => `_${n.toLowerCase()}`);

/*
Affiliate ID: aid=964005
Hostname: hostname=www.booking.com
Hotel ID: hotel_id=98251
Stage: stage=0
Check-in date (YYYY-mm-dd): checkin=2012-12-14
Check-out date (YYYY-mm-dd): checkout=2012-12-15
Number of rooms: nr_rooms_9825101_8806_0=2
*/

export function bookingDotcomUrl(opts, website) {
  const base = website || "https://secure.booking.com/book.html";

  const defaults = {
    hotelId: null,
    checkin: null,
    checkout: null,
    stage: 0,
    aid: 964005,
    hostname: "www.booking.com",
  };

  const options = _.assign({}, defaults, opts);
  options.hotelId = `${options.hotelId}`.replace(/bdc/, "");
  const query = _.map(options, (value, key) => `${lowerUnder(key)}=${value}`).join("&");

  return `${base}?${query}`;
}

export function hostelWorldUrl(opts) {
  const base = "www.hostelworld.com/hosteldetails.php";

  const defaults = {
    affiliate: "lonelyplanet.com",
    dateFrom: null,
    dateTo: null,
    propNum: null,
  };

  const options = _.pickBy(_.assign({}, defaults, opts), _.filter);

  options.propNum = `${options.propNum}`.replace(/hw/, "");

  const query = _.map(options, (value, key) => `${key}=${value}`).join("&");

  return `http://${base}?${query}#availability`;
}



// WEBPACK FOOTER //
// ./assets/pois/utils/bookingUrl.js